<template>
  <div v-if="error" class="login-alert p-3 text-center mb-3">
    <div class="text-primary">{{ error.error }}</div>
    <span v-html="error.msg"></span>
  </div>

  <div v-if="sign">
    <!-- <div class="mb-3 fw-bold">
      Для подписания документа с помощью Подпислон необходимо:
    </div> -->

    <div class="row mb-4">
      <div class="col-auto">
        <div class="nopaper-step">1</div>
      </div>

      <div class="col pt-1">
        Вам отправлено SMS-сообщение с ссылкой на документы, который необходимо
        подписать.
        <div class="mt-2">
          На указанный номер телефона:
          <span class="fw-bold">{{ props.phone }}</span>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-auto">
        <div class="nopaper-step">2</div>
      </div>

      <div class="col pt-1">Подпишите документы.</div>
    </div>

    <div class="login-alert p-3 text-center mb-3">
      <div class="text-primary">Статус</div>
      <span>Документ передан в Подпислон для подписания</span>
    </div>

    <div class="d-flex flex-wrap gap-2">
      <ui-button
        @click="statusPodpislon"
        :loading="loading"
        :disabled="loading"
        class="btn-base"
        >Обновить статус</ui-button
      >
      <ui-button
        @click="closePodpislon"
        :disabled="loading"
        class="btn btn-ghost"
        >Отклонить</ui-button
      >
    </div>

    <div class="mt-3">
      * Для отмены подписания при помощи ПЭП нажмите кнопку Отклонить
    </div>
  </div>

  <div v-else>
    <div class="row">
      <div class="col-12">
        <div class="mb-3 fw-bold">
          Для подписания документа в сервисе Подпислон (ПЭП) потребуется только
          телефон
        </div>
      </div>
    </div>

    <div class="d-flex flex-wrap gap-2">
      <ui-button @click="podpislon" :loading="loading" class="btn-base"
        >Подписать</ui-button
      >
      <a href="https://podpislon.ru/" target="_blank" class="btn btn-ghost"
        >О сервисе Подпислон</a
      >
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";

import { useStore } from "vuex";

const store = useStore();

import { postApi } from "../../run";

const props = defineProps({
  uid: String,
  inn: {
    type: String,
  },
  phone: {
    type: String,
  },
  getFile: {
    type: Function,
    default: () => false,
  },
  setStatus: {
    type: Function,
  },
});

const error = ref(false);
const sign = computed(() => store.state.main.status > 0);
const loading = ref(false);

const podpislon = async () => {
  error.value = null;
  loading.value = true;
  await props
    .getFile()
    .then(async (res) => {
      if (res.error) {
        error.value = res;
      } else {
        await postApi("/podpislon", {
          UID: props.uid,
          base64File: res,
        }).then((res) => {
          if (res.error) {
            error.value = res;
          } else {
            props.setStatus(10);
          }
        });
      }
    })
    .finally(() => {
      loading.value = false;
    });
};

const statusPodpislon = () => {
  error.value = null;
  loading.value = true;
  postApi("/statusPodpislon", {
    UID: props.uid,
  })
    .then((res) => {
      if (res.error) {
        error.value = res;
      } else {
        props.setStatus(res.status);
      }
    })
    .finally(() => {
      loading.value = false;
    });
};

const closePodpislon = () => {
  error.value = null;
  loading.value = true;
  postApi("/closePodpislon", {
    UID: props.uid,
  })
    .then((res) => {
      if (res.error) {
        error.value = res;
      } else {
        props.setStatus(res.status);
      }
    })
    .finally(() => {
      loading.value = false;
    });
};
</script>